import PopupActions from '../../../actions/PopupActions';
import UserStore from '../../../stores/UserStore';
import Price from '../../form/Price.react';
import Increase from '../selected/Increase.react';
import Decrease from '../selected/Decrease.react';
import RemoveAll from '../selected/RemoveAll.react';
import UpdateQuantity from '../selected/UpdateQuantity.react';
import PrintActions from '../../../actions/PrintActions';
import EditCartItem from './EditCartItem.react';
import EditWholeSale from './EditWholeSale.react';

class Cart extends React.Component {

    constructor(props) {
        super(props);

        var selectedLocation = UserStore.getState().selectedLocation;

        this.state = {
            uuid     : uuid(),
            showEdit : selectedLocation.EditCart || selectedLocation.EditCartPartial,
            editWholeSale : selectedLocation.CompanyFlag === 'Dispensary' ? false : true,
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle(e) {
        var uuid = this.state.uuid;

        if (e.target.className.indexOf('tgle') === -1)
            return;

        var left = $('#'+uuid).offset().left ? $('#'+uuid).offset().left : 0;
        var top = $('#'+uuid).offset().top ? $('#'+uuid).offset().top : 0;

        var x = e.pageX - left;
        var y = e.pageY - top;

        if (x > 660 || y > 80)
            return;

        $('#'+uuid).css({
            'height' : $('#'+uuid).height() <= 80 ? 500 : 79,
        });
    }

    render() {
        var guest                = this.props.guest;
        var cart                 = this.props.cart;
        var item                 = this.props.item;
        var i                    = this.props.i;
        let selectedLocation = UserStore.getState().selectedLocation;
        let hidePlusMinus = !selectedLocation.EnableCartPlusMinus;

        return (
            <div
                className={'pos-search__item tgle '+(i % 2 ? 'pos-search__item--grey' : '')}
                id={this.state.uuid}
                onClick={this.toggle}>

                <div className='pos-search__item--qty tgle'>
                    {item.QtySelected}
                </div>

                <div
                    className='cart-item__item--desc tgle'
                    title={item.Product}>

                    {item.Product}
                </div>
                <div
                    className='cart-item__item--serial tgle'
                    title={item.SerialNo}>

                    {item.SerialNo}
                </div>

                <div className='pos-search__item--price tgle'>
                    <Price price={item.TotalCost} dollar={true} className='tgle' />
                </div>

                <div className='pos-search__item--discount tgle'>
                    <Price price={item.DiscountAmt} dollar={true} className='tgle' />
                </div>

                <div className='pos-search__item--weight tgle'>
                    {item.Equivalent}g
                </div>

               
                    <Increase
                        item={item}
                        guest={guest}
                        page='cart'
                        hide={hidePlusMinus}
                    />
                    <Decrease
                        item={item}
                        guest={guest}
                    />
                

                <div className='cart-item__options'>
                    { !guest.IsPaid &&
                        <div
                            className='cart-item__options--discount btn-green'
                            onClick={() => { PopupActions.open('discount', item, guest); }}>

                            DISCOUNT
                        </div>
                    }
                    
                    <div
                        className='cart-item__options--print btn-green'
                        onClick={() => { PrintActions.printLabel(item, guest, false, false); }}>

                        PRINT ONE LABEL
                    </div>

                    <div
                        className='cart-item__options--print-all btn-green'
                        onClick={() => { PrintActions.printLabel(item, guest, true, false); }}>

                        PRINT ALL LABELS
                    </div>

                    { !guest.IsPaid && selectedLocation.UseSpringBig &&
                        <div
                            className='cart-item__options--redeem btn-green'
                            onClick={() => { PopupActions.open('redeem', item, guest); }}>

                            REDEEM SB
                        </div>
                    }

                    { !hidePlusMinus && item.WgtCnt === 'Qty' &&
                        <UpdateQuantity
                            item={item}
                            guest={guest}
                            cart={cart} />
                    }

                    <RemoveAll
                        item={item}
                        guest={guest}
                        cart={cart} 
                    />

                    { !this.state.editWholeSale && this.state.showEdit &&
                        <EditCartItem
                            item={item}
                            guest={guest} />
                    }

                    { this.state.editWholeSale &&
                        <EditWholeSale
                            item={item}
                            guest={guest} />
                    }
                </div>
            </div>
        );
    }
}

export default Cart;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/cart/CartItem.react.jsx